import { maintenanceTemplateKindSchema } from '@gb-ticket/shared-types';
import { z } from 'zod';
import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api';

const schema = z.object({
  items: z.array(
    z.object({
      id: z.string().uuid(),
      templateId: z.string().uuid(),
      templateName: z.string(),
      templateKind: maintenanceTemplateKindSchema,
      versionNumber: z.number().int(),
      requireCustomerSignature: z.boolean(),
    }),
  ),
});

export function usePublishedTemplateVersions(installationId: string) {
  return useQuery({
    queryKey: ['maintenance', 'published-versions', installationId],
    queryFn: () =>
      apiFetch(`/maintenance/installations/${installationId}/published-template-versions`, schema),
    enabled: Boolean(installationId),
  });
}
